<template lang="pug">
  v-content
    v-container(fluid grid-list-md)
      v-layout(row wrap)
        v-flex(xs12)
          v-card
            v-card-text
              v-layout(row wrap)
                v-flex(xs12)
                  v-btn(@click="exportConfirm" color="success" :loading="loading.export") 出力
            v-card-text
              v-layout()
                v-flex(md12)
                  v-card
                    v-card-text
                      ProvisionalOrderFilterConditions(@onChangeSearchConditions="onChangeSearchConditions" ref="filter")
            v-card-text
              v-layout(row wrap)
                v-flex(xs12)
                  AlertBox(ref="alertBox")
                v-flex(xs12)
                  v-btn(@click="openEditDialog" color="primary") 新規追加
                  v-btn(@click="openBulkFormalOrderDialog" color="success" :disabled="!isAnyCardSelected") 一括正式受注登録
                  v-btn(@click="openBulkLostOrderDialog" color="warning" :disabled="!isAnyCardSelected") 一括失注登録


                  span 検索結果該当カード数：
                  span.font-weight-bold {{ searchResultTotalCount }}
                  span 枚

                  // 受注希望確認ダイアログ
                  ConfirmDialog(ref="bulkFormalOrderConfirmDialog" message="選択されたカードを一括で正式受注登録しますか？" title="一括正式受注確認"
                    @yes="executeBulkFormalOrderRequest")

          v-card
            v-card-text
              ProvisionalOrderList(ref="ProvisionalOrderList" :prop-header="tableHeader"
                :prop-data="listData" @open-detail="openDetail" displaySlotBody displaySlotHeader
              detail-url="provisionalOrder/fetchOne" :get-list-action-name="listActionName")
                template(v-slot:head)
                  th.text-xs-center.checkbox-column
                    v-checkbox(v-model="allSelected" @click.stop="onClickAllSelect")
                  th 受付番号/受付日
                  th 荷主/荷主枝番
                  th 積地
                  th 卸地
                  th(style="width:230px") 積込/納品予定日
                  th 車格積載重量
                  th 荷役区分
                  th 運賃計
                  th 配車メモ
                  th 仮受注状態
                template(v-slot:body="item")
                  td.text-xs-center.checkbox-column
                    v-checkbox(:input-value="item.body.selected" @change="onItemSelectionChange(item.index, $event)")
                  td
                    span {{item.body.provisionalOrderDetailNo}}
                    div {{item.body.orderDate}}
                  td
                    span {{item.body.clientName}}
                    div(v-if="item.body.clientBranchName") {{item.body.clientBranchName}}
                  td
                    div
                      template(v-if="item.body.loadingBaseList" v-for="(base) in item.body.loadingBaseList" )
                        div {{base.nameAndCd}}
                      template(v-if="!item.body.loadingBaseList")
                        template(v-if="item.body.loadingBaseMemo")
                          div {{item.body.loadingBaseMemo}}
                        template(v-if="item.body.loadingBaseMemoAreaName")
                          div {{item.body.loadingBaseMemoAreaName}}

                  td
                    div
                      template(v-if="item.body.unloadingBaseList" v-for="(base) in item.body.unloadingBaseList" )
                        div {{base.nameAndCd}}
                      template(v-if="!item.body.unloadingBaseList")
                        template(v-if="item.body.unloadingBaseMemo")
                          div {{item.body.unloadingBaseMemo}}
                        template(v-if="item.body.unloadingBaseMemoAreaName")
                          div {{item.body.unloadingBaseMemoAreaName}}
                  td
                    template(v-if="item.body.equalLoadingDate")
                      span {{item.body.loadingDateFrom}}
                    template(v-else)
                      span {{item.body.loadingDateFrom}} ～ {{item.body.loadingDateTo}}

                    div.text-xs-center ↓

                    template(v-if="item.body.equalUnloadingDate")
                      span {{item.body.unloadingDateFrom}}
                    template(v-else)
                      span {{item.body.unloadingDateFrom}} ～ {{item.body.unloadingDateTo}}
                  td {{item.body.vehicleWeightName}}
                  td {{item.body.handlingUnitTypeName}}
                  td
                    DigitSeparatorsLabel(:value="item.body.totalFareSubtotalPrice").price
                  td {{item.body.dispatchMemo}}
                  td
                    span {{getProvisionalOrderStatusTypeLabel(item.body.provisionalOrderStatus)}}
                    div(v-if="item.body.cardId") カードID:{{item.body.cardId}}

    ProvisionalManualOrderEdit(ref="editProvisionalDialog" @updated="itemUpdated" @deleted="itemUpdated")
    ExportConfirmDialog(ref="ExportConfirmDialog" @yes="exportData('provisionalOrder/export')")

      // 失注保存の確認ダイアログ
    ProvisionalOrderLossConfirmDialog(ref="ProvisionalOrderLossConfirmDialog"
      :requestParams="bulkParams"
      :post-url="$config.urls.postProvisionalOrderBulkLoss" @saved="onSavedBulkLostOrderStatus"
    )
</template>

<script>
import ManualOrderListTable from "@/components/order/ManualOrderListTable";
import ReloadButton from "@/components/common/buttons/ReloadButton";
import BjiOrderSummaryListTable from "@/components/order/BjiOrderSummaryListTable";
import ExportConfirmDialog from "@/components/common/dialog/ExportConfirmDialog";
import OrderCount from "@/components/order/OrderCount";
import ProvisionalOrderList from "@/components/common/PagingListTable.vue";

import ExportHandler from "@/mixin/ExportHandler";
import EventDispatcher from "@/mixin/EventDispatcher";
import ProvisionalOrderFilterConditions from "@/components/order/ProvisionalOrderFilterConditions.vue";
import * as Enum from "@/assets/js/enum";
import ProvisionalManualOrderEdit from "@/components/order/ProvisionalManualOrderEdit.vue";
import ConfirmDialog from "@/components/common/dialog/ConfirmDialog.vue";
import AlertBox from "@/components/common/AlertBox.vue";
import ProvisionalOrderLossConfirmDialog from "@/components/common/dialog/ProvisionalOrderLossConfirmDialog.vue";
import DigitSeparatorsLabel from "@/components/common/DigitSeparatorsLabel.vue";

export default {
  components: {
    DigitSeparatorsLabel,
    AlertBox,
    ConfirmDialog,
    ProvisionalManualOrderEdit,
    ProvisionalOrderFilterConditions,
    ProvisionalOrderList,
    ManualOrderListTable,
    ReloadButton,
    BjiOrderSummaryListTable,
    ExportConfirmDialog,
    OrderCount,
    ProvisionalOrderLossConfirmDialog
  },
  mixins: [ExportHandler, EventDispatcher],
  data() {
    return {};
  },
  watch: {
    loading: function (value) {
      if (value === false) {
        //一覧の検索やクリアボタンローディング制御の為にイベント発行。
        this.dispatchCommonEvent(window.Common.Config.observer.onPagingListTableAjaxCompleted);
      }
    }
  },
  computed: {
    searchResultTotalCount: {
      get() {
        return this.$store.state.provisionalOrder.searchResultTotalCount;
      }
    },
    listData: {
      get() {
        return this.$store.state.provisionalOrder.resultList;
      }
    },
    allSelected: {
      get() {
        return this.$store.state.provisionalOrder.allSelected;
      },
      set(value) {
        this.$store.commit("provisionalOrder/updateAllSelection", value);
      }
    },
    listActionName: {
      get() {
        return "provisionalOrder/fetchAll";
      }
    },
    tableHeader: {
      get() {
        return [
          { text: "選択", value: "provisionalOrderNo", centerAlign: false },
          { text: "受付番号/受付日", value: "provisionalOrderNo", centerAlign: false },
          { text: "荷主/荷主枝番", value: "clientId", centerAlign: false },
          { text: "積地", value: "loadingBaseId", centerAlign: false },
          { text: "卸地", value: "unloadingBaseId", centerAlign: false },
          { text: "積込/納品予定日", value: "loadingDate", centerAlign: false },
          { text: "車格積載重量", value: "vehicleWeight", centerAlign: false },
          { text: "仮受注状態", value: "provisionalOrderStatus", centerAlign: false }
        ];
      }
    },
    isSelectCard: {
      get() {
        const hasSelected = this.$store.getters["provisionalOrder/hasSelected"];
        console.log("hasSelected:", hasSelected);
        return hasSelected;
      }
    },
    isAnyCardSelected: {
      get() {
        return this.allSelected || this.isSelectCard;
      }
    },
    bulkParams: {
      get() {
        let selectedProvisionalOrderCardIdList = false;
        if (this.allSelected) {
          selectedProvisionalOrderCardIdList = this.listData
            .filter(item => !item.selected)
            .map(item => item.id);
        } else {
          selectedProvisionalOrderCardIdList = this.listData
            .filter(item => item.selected)
            .map(item => item.id);
        }

        return Object.assign({}, this.searchCond, {
          provisionalOrderCardIdList: selectedProvisionalOrderCardIdList,
          allSelected: this.allSelected
        });
      }
    }
  },
  methods: {
    /**
     * 新規作成ダイアログの表示
     */
    openEditDialog() {
      this.$refs.editProvisionalDialog.openDialog(undefined);
    },
    /**
     * 詳細ダイアログの表示
     * @param item
     */
    openDetail(item) {
      this.$refs.editProvisionalDialog.openDialog(item);
    },
    /**
     * データの読み込み
     * @param params
     */
    loadListData() {
      this.clearErrorMessage();
      this.$refs.ProvisionalOrderList.loadData();
    },
    /**
     * レコード追加・更新・削除時に検索同様ページ番号0にして再取得
     */
    itemUpdated(response, data) {
      this.$refs.ProvisionalOrderList.resetPageCount();
      this.loadListData();
    },
    onChangeSearchConditions(searchCond) {
      this.searchCond = searchCond;
      this.$refs.ProvisionalOrderList.setSearchConditions(searchCond);
      this.$refs.ProvisionalOrderList.resetPageCount();
      this.allSelected = false;
      this.loadListData();
    },
    initSearchCond() {
      return {
        conditions: {
          clientName: "",
          transportType: "",
          loadingDate: null,
          loadingPlace: "",
          unloadingDate: null,
          unloadingPlace: "",
          orderDate: null,
          billingTypeName: "",
          distanceType: "",
          dispatchStatusList: "",
          specifiedTimeType: ""
        }
      };
    },
    getProvisionalOrderStatusTypeLabel(code) {
      return Enum.Utils.findLabel(code, Enum.ProvisionalOrderStatusType);
    },
    onClickAllSelect() {
      this.allSelected = !this.allSelected;
    },
    onItemSelectionChange(index, selected) {
      this.$store.commit("provisionalOrder/updateItemSelection", { index, selected });
    },
    /**
     * 出力ダイアログの表示
     */
    exportConfirm() {
      this.$refs.ExportConfirmDialog.openDialog();
    },
    openBulkFormalOrderDialog() {
      this.$refs.bulkFormalOrderConfirmDialog.openDialog();
    },
    openBulkLostOrderDialog() {
      this.$refs.ProvisionalOrderLossConfirmDialog.openDialog();
    },

    async executeBulkFormalOrderRequest() {
      this.clearErrorMessage();

      try {
        await this.$store.dispatch("provisionalOrder/bulkFormalOrderRequest", this.bulkParams);
        this.itemUpdated();
      } catch (e) {
        this.$refs.alertBox.displayMessage(e.message);
      }
    },

    clearErrorMessage() {
      this.$refs.alertBox.nonDisplayMessage();
    },
    async onSavedBulkLostOrderStatus() {
      this.itemUpdated();
    }
  },

  mounted() {
    this.$refs.filter.triggerSearch();
  }
};
</script>

<style lang="stylus" scoped>
.checkbox-column
  .v-input--checkbox
    margin 0 auto
    display table
</style>
